angular.module("kitstajm").factory("CommonUtils", function () {

  function sortByIndex(array, name, type = "string", ascending = true) {
    return array.sort(function (a, b) {
      let va = a[name];
      let vb = b[name];

      switch (type) {
        case "number":
          va = Number(va);
          vb = Number(vb);
          if (isNaN(va)) return 1; // NaN sist
          if (isNaN(vb)) return -1; // NaN sist
          return (va - vb) * (ascending ? 1 : -1);

        case "date":
          if (va == null && vb == null) return 0;
          if (va == null) return 1;  // a sist, alltid
          if (vb == null) return -1; // b sist, alltid

          const da = new Date(a[name]);
          const db = new Date(b[name]);

          // Båda giltiga → sortering beroende på ascending
          return ascending ? da - db : db - da;

        case "string":
        default:
          // Hantera null eller tomma strängar
          if (va == null || va === "") return 1;
          if (vb == null || vb === "") return -1;

          return String(va).localeCompare(String(vb), "sv", { sensitivity: "base" }) * (ascending ? 1 : -1);
      }
    });
  }


  return {
    sortByIndex: sortByIndex,
  };
});
